export default __webpack_public_path__ + "pl.e09f7c16.png";